export default "__VITE_ASSET__B$DBKpyC__"